import { Select } from "antd";
import { usePlantingsList } from "@/modules/plantings/hooks/usePlantings";

interface PlantingMultiSelectProps {
	organizationId?: string;
	value?: string[];
	onChange?: (value: string[]) => void;
	placeholder?: string;
}

/** Searchable multi-select over an organization's plantings — used to pick PLANT-type task targets. */
export function PlantingMultiSelect({
	organizationId,
	value,
	onChange,
	placeholder,
}: PlantingMultiSelectProps) {
	const { data, isLoading } = usePlantingsList({
		organizationId,
		page: 1,
		limit: 100,
	});
	const plantings = data?.data?.items ?? [];

	return (
		<Select
			mode="multiple"
			value={value}
			onChange={onChange}
			loading={isLoading}
			disabled={!organizationId}
			placeholder={placeholder ?? "Ekin(lar)ni tanlang"}
			showSearch
			optionFilterProp="label"
			options={plantings.map((p) => ({
				value: p.id,
				label: p.territoryName ? `${p.plantName} — ${p.territoryName}` : (p.plantName ?? p.plantId),
			}))}
		/>
	);
}
